import icPdf from "../../assets/ic-doc/pdf.svg";
import icImage from "../../assets/ic-doc/image.svg";
import icTxt from "../../assets/ic-doc/text.svg";
import { GoFileZip } from "react-icons/go";
import { MdDownload } from "react-icons/md";
import { imageFromUuid } from "../../helpers/utility";

const DocImg = ({ file, compact = false }) => {
    
    let url = icImage;
    let isZipFile = false;

    if( file?.mime_type && file?.mime_type == 'application/pdf'){
        url = icPdf
    }
    else if(['image/png', 'image/jpeg', 'image/gif'].includes(file?.mime_type)){
        url = imageFromUuid(file?.attachment_id);
    }
    else if(file?.mime_type == 'text/plain'){
        url = icTxt
    }
    else if(file?.mime_type == 'application/zip'){
        isZipFile = true;
    }

    return (
        <div className={`flex gap-2 items-center border border-gray-300 rounded-lg relative p-2 min-w-0 ${compact ? 'max-w-full w-full' : ''}`}>
            {isZipFile ? 
                <GoFileZip className="h-10 w-10 shrink-0 text-blue-500" /> 
                : 
                <img src={url} className="h-10 w-10 shrink-0 rounded-lg" alt="" />
            }
            <div className="flex items-center min-w-0">
            <span className={`text-sm pr-2 text-left truncate ${compact ? 'max-w-full' : 'max-w-[300px] md:max-w-none'}`}>{file?.title}</span>
            {isZipFile && (
                <MdDownload className="text-blue-600 h-5 w-5" />
            )}
            </div>
        </div>
    );
};

export default DocImg;